import { createIcon } from './factory'
import Icon from './paper-plane-tilt.svg?react'

export const PaperPlaneTilt = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
